/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiCompoundingReason,
  ApiCompoundingReasonFromJSON,
  ApiCompoundingReasonFromJSONTyped,
  ApiCompoundingReasonToJSON,
} from './ApiCompoundingReason';
import {
  ApiPetPrescriptionLastOrder,
  ApiPetPrescriptionLastOrderFromJSON,
  ApiPetPrescriptionLastOrderFromJSONTyped,
  ApiPetPrescriptionLastOrderToJSON,
} from './ApiPetPrescriptionLastOrder';

/**
 *
 * @export
 * @interface ApiPetPrescription
 */
export interface ApiPetPrescription {
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  legacyId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  userId?: number;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  userName?: string;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  petId?: number;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  petName?: string;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  vetId?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  oldVetId?: number;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  vetName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  clientId?: string;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  clinicId?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  oldClinicId?: number;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  clinicName?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  clinicPhone?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  partNumber?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  partName?: string;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  itemId?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  itemParentId?: number;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  itemType?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  gtin?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  fullImage?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  thumbnail?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiPetPrescription
   */
  isBundle?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiPetPrescription
   */
  isChewyFresh?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  type?: ApiPetPrescriptionTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  prescribedDate?: string;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  createdById?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  updatedById?: number;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  prescriptionExpirationDate?: string;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  updatedAt?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  statusCode?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  durStatusCode?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  durModifierId?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  durAt?: number;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  businessUnit?: ApiPetPrescriptionBusinessUnitEnum;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  siteId?: number;
  /**
   *
   * @type {boolean}
   * @memberof ApiPetPrescription
   */
  isUnlimited?: boolean;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  amountUsed?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  refillAmount?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  amountRemaining?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  quantityPrescribed?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  amountAllowed?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  itemPackageQuantity?: number;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  itemUnitType?: ApiPetPrescriptionItemUnitTypeEnum;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  itemExpirationDate?: string;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  approvedAt?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  approverId?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  deniedAt?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  denierId?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  closedAt?: number;
  /**
   *
   * @type {number}
   * @memberof ApiPetPrescription
   */
  closerId?: number;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  changeStatusReason?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  directions?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  notes?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiPetPrescription
   */
  dispenseAsWritten?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiPetPrescription
   */
  giveWithFood?: boolean;
  /**
   *
   * @type {Array<ApiCompoundingReason>}
   * @memberof ApiPetPrescription
   */
  compoundingReasons?: Array<ApiCompoundingReason>;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  compoundingReasonComment?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  compoundingAllergyComment?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiPetPrescription
   */
  compounded?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ApiPetPrescription
   */
  hasAttachment?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  prescriptionLink?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiPetPrescription
   */
  unverified?: boolean;
  /**
   *
   * @type {ApiPetPrescriptionLastOrder}
   * @memberof ApiPetPrescription
   */
  lastOrder?: ApiPetPrescriptionLastOrder;
  /**
   *
   * @type {boolean}
   * @memberof ApiPetPrescription
   */
  equivalentMatch?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiPetPrescription
   */
  approvalChannel?: string;
}

/**
 * @export
 */
export const ApiPetPrescriptionTypeEnum = {
  Rx: 'RX',
  Px: 'PX',
} as const;
export type ApiPetPrescriptionTypeEnum = typeof ApiPetPrescriptionTypeEnum[keyof typeof ApiPetPrescriptionTypeEnum];

/**
 * @export
 */
export const ApiPetPrescriptionBusinessUnitEnum = {
  B2C: 'B2C',
  B2B: 'B2B',
} as const;
export type ApiPetPrescriptionBusinessUnitEnum = typeof ApiPetPrescriptionBusinessUnitEnum[keyof typeof ApiPetPrescriptionBusinessUnitEnum];

/**
 * @export
 */
export const ApiPetPrescriptionItemUnitTypeEnum = {
  Gm: 'GM',
  Lbs: 'LBS',
  Ml: 'ML',
  Oz: 'OZ',
  Bags: 'BAGS',
  Bottles: 'BOTTLES',
  Boxes: 'BOXES',
  Cans: 'CANS',
  Caplets: 'CAPLETS',
  Capsules: 'CAPSULES',
  Inhaler: 'INHALER',
  Item: 'ITEM',
  Needles: 'NEEDLES',
  Pack: 'PACK',
  Pouches: 'POUCHES',
  Scoops: 'SCOOPS',
  Syringes: 'SYRINGES',
  Tablets: 'TABLETS',
  Tubes: 'TUBES',
  Vials: 'VIALS',
} as const;
export type ApiPetPrescriptionItemUnitTypeEnum = typeof ApiPetPrescriptionItemUnitTypeEnum[keyof typeof ApiPetPrescriptionItemUnitTypeEnum];

export function ApiPetPrescriptionFromJSON(json: any): ApiPetPrescription {
  return ApiPetPrescriptionFromJSONTyped(json, false);
}

export function ApiPetPrescriptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPetPrescription {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    legacyId: !exists(json, 'legacyId') ? undefined : json['legacyId'],
    userId: !exists(json, 'userId') ? undefined : json['userId'],
    userName: !exists(json, 'userName') ? undefined : json['userName'],
    petId: !exists(json, 'petId') ? undefined : json['petId'],
    petName: !exists(json, 'petName') ? undefined : json['petName'],
    vetId: !exists(json, 'vetId') ? undefined : json['vetId'],
    oldVetId: !exists(json, 'oldVetId') ? undefined : json['oldVetId'],
    vetName: !exists(json, 'vetName') ? undefined : json['vetName'],
    clientId: !exists(json, 'clientId') ? undefined : json['clientId'],
    clinicId: !exists(json, 'clinicId') ? undefined : json['clinicId'],
    oldClinicId: !exists(json, 'oldClinicId') ? undefined : json['oldClinicId'],
    clinicName: !exists(json, 'clinicName') ? undefined : json['clinicName'],
    clinicPhone: !exists(json, 'clinicPhone') ? undefined : json['clinicPhone'],
    partNumber: !exists(json, 'partNumber') ? undefined : json['partNumber'],
    partName: !exists(json, 'partName') ? undefined : json['partName'],
    itemId: !exists(json, 'itemId') ? undefined : json['itemId'],
    itemParentId: !exists(json, 'itemParentId') ? undefined : json['itemParentId'],
    itemType: !exists(json, 'itemType') ? undefined : json['itemType'],
    gtin: !exists(json, 'gtin') ? undefined : json['gtin'],
    fullImage: !exists(json, 'fullImage') ? undefined : json['fullImage'],
    thumbnail: !exists(json, 'thumbnail') ? undefined : json['thumbnail'],
    isBundle: !exists(json, 'isBundle') ? undefined : json['isBundle'],
    isChewyFresh: !exists(json, 'isChewyFresh') ? undefined : json['isChewyFresh'],
    type: !exists(json, 'type') ? undefined : json['type'],
    prescribedDate: !exists(json, 'prescribedDate') ? undefined : json['prescribedDate'],
    createdById: !exists(json, 'createdById') ? undefined : json['createdById'],
    updatedById: !exists(json, 'updatedById') ? undefined : json['updatedById'],
    prescriptionExpirationDate: !exists(json, 'prescriptionExpirationDate')
      ? undefined
      : json['prescriptionExpirationDate'],
    createdAt: !exists(json, 'createdAt') ? undefined : json['createdAt'],
    updatedAt: !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
    statusCode: !exists(json, 'statusCode') ? undefined : json['statusCode'],
    durStatusCode: !exists(json, 'durStatusCode') ? undefined : json['durStatusCode'],
    durModifierId: !exists(json, 'durModifierId') ? undefined : json['durModifierId'],
    durAt: !exists(json, 'durAt') ? undefined : json['durAt'],
    businessUnit: !exists(json, 'businessUnit') ? undefined : json['businessUnit'],
    siteId: !exists(json, 'siteId') ? undefined : json['siteId'],
    isUnlimited: !exists(json, 'isUnlimited') ? undefined : json['isUnlimited'],
    amountUsed: !exists(json, 'amountUsed') ? undefined : json['amountUsed'],
    refillAmount: !exists(json, 'refillAmount') ? undefined : json['refillAmount'],
    amountRemaining: !exists(json, 'amountRemaining') ? undefined : json['amountRemaining'],
    quantityPrescribed: !exists(json, 'quantityPrescribed')
      ? undefined
      : json['quantityPrescribed'],
    amountAllowed: !exists(json, 'amountAllowed') ? undefined : json['amountAllowed'],
    itemPackageQuantity: !exists(json, 'itemPackageQuantity')
      ? undefined
      : json['itemPackageQuantity'],
    itemUnitType: !exists(json, 'itemUnitType') ? undefined : json['itemUnitType'],
    itemExpirationDate: !exists(json, 'itemExpirationDate')
      ? undefined
      : json['itemExpirationDate'],
    approvedAt: !exists(json, 'approvedAt') ? undefined : json['approvedAt'],
    approverId: !exists(json, 'approverId') ? undefined : json['approverId'],
    deniedAt: !exists(json, 'deniedAt') ? undefined : json['deniedAt'],
    denierId: !exists(json, 'denierId') ? undefined : json['denierId'],
    closedAt: !exists(json, 'closedAt') ? undefined : json['closedAt'],
    closerId: !exists(json, 'closerId') ? undefined : json['closerId'],
    changeStatusReason: !exists(json, 'changeStatusReason')
      ? undefined
      : json['changeStatusReason'],
    directions: !exists(json, 'directions') ? undefined : json['directions'],
    notes: !exists(json, 'notes') ? undefined : json['notes'],
    dispenseAsWritten: !exists(json, 'dispenseAsWritten') ? undefined : json['dispenseAsWritten'],
    giveWithFood: !exists(json, 'giveWithFood') ? undefined : json['giveWithFood'],
    compoundingReasons: !exists(json, 'compoundingReasons')
      ? undefined
      : (json['compoundingReasons'] as Array<any>).map(ApiCompoundingReasonFromJSON),
    compoundingReasonComment: !exists(json, 'compoundingReasonComment')
      ? undefined
      : json['compoundingReasonComment'],
    compoundingAllergyComment: !exists(json, 'compoundingAllergyComment')
      ? undefined
      : json['compoundingAllergyComment'],
    compounded: !exists(json, 'compounded') ? undefined : json['compounded'],
    hasAttachment: !exists(json, 'hasAttachment') ? undefined : json['hasAttachment'],
    prescriptionLink: !exists(json, 'prescriptionLink') ? undefined : json['prescriptionLink'],
    unverified: !exists(json, 'unverified') ? undefined : json['unverified'],
    lastOrder: !exists(json, 'lastOrder')
      ? undefined
      : ApiPetPrescriptionLastOrderFromJSON(json['lastOrder']),
    equivalentMatch: !exists(json, 'equivalentMatch') ? undefined : json['equivalentMatch'],
    approvalChannel: !exists(json, 'approvalChannel') ? undefined : json['approvalChannel'],
  };
}

export function ApiPetPrescriptionToJSON(value?: ApiPetPrescription | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    legacyId: value.legacyId,
    userId: value.userId,
    userName: value.userName,
    petId: value.petId,
    petName: value.petName,
    vetId: value.vetId,
    oldVetId: value.oldVetId,
    vetName: value.vetName,
    clientId: value.clientId,
    clinicId: value.clinicId,
    oldClinicId: value.oldClinicId,
    clinicName: value.clinicName,
    clinicPhone: value.clinicPhone,
    partNumber: value.partNumber,
    partName: value.partName,
    itemId: value.itemId,
    itemParentId: value.itemParentId,
    itemType: value.itemType,
    gtin: value.gtin,
    fullImage: value.fullImage,
    thumbnail: value.thumbnail,
    isBundle: value.isBundle,
    isChewyFresh: value.isChewyFresh,
    type: value.type,
    prescribedDate: value.prescribedDate,
    createdById: value.createdById,
    updatedById: value.updatedById,
    prescriptionExpirationDate: value.prescriptionExpirationDate,
    createdAt: value.createdAt,
    updatedAt: value.updatedAt,
    statusCode: value.statusCode,
    durStatusCode: value.durStatusCode,
    durModifierId: value.durModifierId,
    durAt: value.durAt,
    businessUnit: value.businessUnit,
    siteId: value.siteId,
    isUnlimited: value.isUnlimited,
    amountUsed: value.amountUsed,
    refillAmount: value.refillAmount,
    amountRemaining: value.amountRemaining,
    quantityPrescribed: value.quantityPrescribed,
    amountAllowed: value.amountAllowed,
    itemPackageQuantity: value.itemPackageQuantity,
    itemUnitType: value.itemUnitType,
    itemExpirationDate: value.itemExpirationDate,
    approvedAt: value.approvedAt,
    approverId: value.approverId,
    deniedAt: value.deniedAt,
    denierId: value.denierId,
    closedAt: value.closedAt,
    closerId: value.closerId,
    changeStatusReason: value.changeStatusReason,
    directions: value.directions,
    notes: value.notes,
    dispenseAsWritten: value.dispenseAsWritten,
    giveWithFood: value.giveWithFood,
    compoundingReasons:
      value.compoundingReasons === undefined
        ? undefined
        : (value.compoundingReasons as Array<any>).map(ApiCompoundingReasonToJSON),
    compoundingReasonComment: value.compoundingReasonComment,
    compoundingAllergyComment: value.compoundingAllergyComment,
    compounded: value.compounded,
    hasAttachment: value.hasAttachment,
    prescriptionLink: value.prescriptionLink,
    unverified: value.unverified,
    lastOrder: ApiPetPrescriptionLastOrderToJSON(value.lastOrder),
    equivalentMatch: value.equivalentMatch,
    approvalChannel: value.approvalChannel,
  };
}
